module.exports = __webpack_public_path__ + "static/media/Briarwood Statement of Allegations Summary.2ddc44b4.pdf";